import DashboardLayout from '../layout/DashboardLayout.vue';
import NewHome from '../pages/NewHome/NewHome.vue';
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue';

// Admin pages
import ControleUsuarios from 'src/pages/ControleUsuarios';
import ControleProdutos from 'src/pages/ControleProdutos';
import ControleAnuncios from 'src/pages/ControleAnuncios';
import ControleConcessionarias from 'src/pages/ControleConcessionarias';
import Produtos from 'src/pages/Produtos';
import Servicos from 'src/pages/Servicos';
import Downloads from 'src/pages/Downloads';
import Perfil from 'src/pages/Perfil';
import EmitirProposta from 'src/pages/EmitirProposta';
import HistoricoPropostas from 'src/pages/HistoricoPropostas';
import DetalhesPropostas from 'src/pages/DetalhesPropostas';
import Login from 'src/pages/Login';
import SobreNos from 'src/pages/SobreNos';
import Solucoes from 'src/pages/Solucoes';
import PertoDeVoce from 'src/pages/PertoDeVoce';
import SuaUsina from 'src/pages/SuaUsina';
import ControleResponsavelEstado from 'src/pages/ControleResponsavelEstado';
import ControleCrm from 'src/pages/CRM/ControleCrm';
import LinhaDoTempoCRM from 'src/pages/CRM/LinhaDoTempo';
import ControleClientes from 'src/pages/Clientes/Controle';
import FormularioCliente from 'src/pages/Clientes/Formulario';
import FormularioCadastroOSCliente from 'src/pages/OS/Formulario';
import ListaProjetosParceiro from 'src/pages/Parceiros/ListaProjetosPorParceiro';
import ControleOsClientes from 'src/pages/OS/Controle';
import Financeiro from 'src/pages/Financeiro/Financeiro';
import FinanceiroPDF from 'src/pages/Financeiro/FinanceiroPDF';
import Vendedores from 'src/pages/Vendedores/Lista';
import Parceiros from 'src/pages/Parceiros/Lista';
import DocsEDadosDoProjeto from 'src/pages/Parceiros/DocsEDadosDoProjeto';
import RelatorioStatusParceiro from 'src/pages/Parceiros/RelatorioStatusParceiro';
import RelatorioAnaliseReanalise from 'src/pages/Parceiros/RelatorioAnaliseReanalise';

const routes = [
  {
    path: '/',
    redirect: '/portal/home'
  },
  { path: '/portal/home', component: NewHome },
  {
    path: '/portal',
    component: DashboardLayout,
    redirect: '/portal/home',
    children: [
      {
        path: 'perfil',
        name: 'perfil',
        component: Perfil,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'login',
        name: 'login',
        component: Login,
        meta: {
          requiresAuth: false
        }
      },
      {
        path: 'sobre-nos',
        name: 'sobreNos',
        component: SobreNos,
        meta: {
          requiresAuth: false
        }
      },
      {
        path: 'perto-de-voce',
        name: 'pertoDeVoce',
        component: PertoDeVoce,
        meta: {
          requiresAuth: false
        }
      },
      {
        path: 'sua-usina',
        name: 'suaUsina',
        component: SuaUsina,
        meta: {
          requiresAuth: false
        }
      },
      {
        path: 'solucoes',
        name: 'solucoes',
        component: Solucoes,
        meta: {
          requiresAuth: false
        }
      },
      {
        path: 'controle-usuarios',
        name: 'controleUsuarios',
        component: ControleUsuarios,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'controle-produtos',
        name: 'controleProdutos',
        component: ControleProdutos,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'controle-anuncios',
        name: 'controleAnuncios',
        component: ControleAnuncios,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'controle-concessionarias',
        name: 'controleConcessionarias',
        component: ControleConcessionarias,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'produtos',
        name: 'produtos',
        component: Produtos,
        meta: {
          requiresAuth: false
        }
      },
      {
        path: 'servicos',
        name: 'servicos',
        component: Servicos,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'downloads',
        name: 'downloads',
        component: Downloads,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'cadastrar-proposta',
        name: 'cadastrarProposta',
        component: EmitirProposta,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'historico-propostas',
        name: 'historicoPropostas',
        component: HistoricoPropostas,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'historico-propostas/:codigo',
        name: 'detalhesPropostas',
        component: DetalhesPropostas,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'controle-responsavel-estado',
        name: 'controleResponsavelEstado',
        component: ControleResponsavelEstado,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'crm',
        name: 'crm',
        component: ControleCrm,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'crm/:codigo',
        name: 'linhaDotempoCrm',
        component: LinhaDoTempoCRM,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'clientes',
        name: 'clientes',
        component: ControleClientes,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'clientes/:codigo',
        name: 'formularioCliente',
        component: FormularioCliente,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'clientes-new',
        name: 'formularioCliente',
        component: FormularioCliente,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'cliente-os-cadastro/:codigoCliente',
        name: 'FormularioCadastroOSCliente',
        component: FormularioCadastroOSCliente,
        props: true,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'ordem-de-servico/:codigoOs',
        name: 'OrdemDeServico',
        component: FormularioCadastroOSCliente,
        props: true,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'ordem-de-servico/aprovacao/:codigoColaboradorDeCampo',
        name: 'OrdemDeServicoAprovacao',
        component: FormularioCadastroOSCliente,
        meta: {
          requiresAuth: false
        }
      },
      {
        path: 'controle-os',
        name: 'ControleOsClientes',
        component: ControleOsClientes,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'financeiro-cliente/:codigoDoCliente',
        name: 'FinanceiroCliente',
        component: Financeiro,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'financeiro-geral',
        name: 'FinanceiroGeral',
        component: Financeiro,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'financeiro-pdf',
        name: 'financeiroPDF',
        component: FinanceiroPDF,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'vendedores',
        name: 'vendedores',
        component: Vendedores,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'parceiros',
        name: 'parceiros',
        component: Parceiros,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'parceiro-clientes/:codigoParceiro',
        name: 'ListaProjetosParceiro',
        component: ListaProjetosParceiro,
        props: true,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'parceiro-relatorio-status/:codigoParceiro',
        name: 'RelatorioStatusParceiro',
        component: RelatorioStatusParceiro,
        props: true,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'parceiro-relatorio-analise-reanalise/:codigoParceiro',
        name: 'RelatorioAnaliseReanalise',
        component: RelatorioAnaliseReanalise,
        props: true,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'parceiro-cliente/:idProjeto',
        name: 'DocsEDadosDoProjeto',
        component: DocsEDadosDoProjeto,
        props: true,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'parceiro-cliente-create/:codigoParceiro',
        name: 'DocsEDadosDoProjetoCreate',
        component: DocsEDadosDoProjeto,
        props: true,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  { path: '*', component: NotFound }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
